import React, { useState } from "react";
import "./ContactPage.css";

const ContactPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(
      `Thank You ${name} for Contacting Us. We will Get Back to You Soon.\n\nYour Mail Id - ${email}.\nYour Message is - ${message}`
    );
    setName("");
    setEmail("");
    setPhone("");
    setMessage("");
  };

  return (
    <>
      <div className="contactSection">
        <h2>📞 We're Here for You!</h2>
        <div className="contactContent">
          <p>
            At <strong>SwasthMitra</strong>, your health, comfort, and trust matter the most.
            <br />
            Whether you have a question, need help placing an order, or just want to say hello — we're always happy to hear from you!
          </p>

          <hr />

          <h3>📨 Get in Touch</h3>
          
          <div className="contactMethods">
            <div className="contactMethod">
              <h4>📧 Email Us:</h4>
              <p>
                For general inquiries or support:
                <br />
                👉 <a href="mailto:info@swasthmitra.com">info@swasthmitra.com</a>
                <br />
                For career opportunities:
                <br />
                👉 <a href="mailto:info@swasthmitra.com">info@swasthmitra.com</a>
              </p>
            </div>
            
            <div className="contactMethod">
              <h4>📞 Call Us:</h4>
              <p>
                Customer Support:
                <br />
                📱 <a href="tel:+917007512120">+91-7007512120</a> (Mon–Sat | 9:00 AM – 7:00 PM)
              </p>
            </div>
            
            <div className="contactMethod">
              <h4>💬 WhatsApp Support:</h4>
              <p>
                Chat with us directly for order updates or queries
                <br />
                📲 <a href="https://wa.me/919118063939" target="_blank" rel="noopener noreferrer">Click to WhatsApp</a>
              </p>
            </div>
          </div>

          <h3>🗺 Our Office Address</h3>
          <div className="officeAddress">
            <p>
              SwasthMitra Healthcare Pvt. Ltd.
              <br />
              [Medical College Road, opposite Medical College Road, Sadar, Vidhyak Niwas]
              <br />
              [Gorakhpur, Uttar Pradesh 273013]
              <br />
              India
            </p>
          </div>

          <h3>🕒 Customer Support Hours</h3>
          <p>
            Monday to Saturday – <strong>9:00 AM to 7:00 PM</strong>
            <br />
            Closed on Sundays and public holidays
          </p>

          <hr />

          <h3>📝 Prefer to Write to Us?</h3>
          <div className="contactForm">
            <form onSubmit={handleSubmit}>
              <div className="formGroup">
                <input
                  type="text"
                  value={name}
                  placeholder="Name *"
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className="formGroup">
                <input
                  type="email"
                  value={email}
                  placeholder="Email Address *"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="formGroup">
                <input
                  type="tel"
                  value={phone}
                  placeholder="Phone Number"
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
              <div className="formGroup">
                <textarea
                  rows={6}
                  placeholder="Your Message / Query *"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                />
              </div>
              <button type="submit">Submit</button>
            </form>
            <p className="responseTime">
              We usually respond within <strong>24 hours</strong>. For urgent issues, please call or WhatsApp us directly.
            </p>
          </div>

          <hr />

          <div className="thankYou">
            <h3>🙏 Thank You for Choosing SwasthMitra</h3>
            <p>
              We're proud to be your health partner.
              <br />
              Together, let's make healthcare simpler, safer, and more accessible.
            </p>
          </div>

          <div className="trustIcons">
            <p>
              🔒 Secure Payments | 🚚 Fast Delivery | 🛡 Genuine Medicines
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;